module.exports = __webpack_public_path__ + "media/images/ibjjf/academy_registration_informations/professor_corrections-d299c0c636d2cac4bdeb2bc4adc7a352.svg";